module.exports = {
    ENDORSEMENTS_PAGING_CHANGE: 'ENDORSEMENTS_PAGING_CHANGE',
    ENDORSEMENTS_SEARCH_ADD: 'ENDORSEMENTS_SEARCH_ADD',
    ENDORSEMENTS_DATA_REQUEST_PENDING: 'ENDORSEMENTS_DATA_REQUEST_PENDING',
    ENDORSEMENTS_DATA_REQUEST_SUCCESS: 'ENDORSEMENTS_DATA_REQUEST_SUCCESS',
    ENDORSEMENTS_DATA_REQUEST_FAILURE: 'ENDORSEMENTS_DATA_REQUEST_FAILURE'
}
